export default __webpack_public_path__ + "33b639d8bf9459b88048dca7884fe6a3.svg";